var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:(_setup.styles.vars)},[_c('h5',{staticClass:"header"},[_vm._v(_vm._s(_setup.props.header))]),_c('div',{staticClass:"spacer"}),_c('div',{staticClass:"input-slot",class:_setup.props.defaultPadding == true ? 'input-slot-padding' : ''},[_vm._t("input")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }